import { MapIcon } from 'lucide-react';
import { Button } from '@/components/ui/primitives';
import { openInNativeMaps, toMapTarget, type MaybeCoordinates } from '@/lib/nativeMaps';

export interface OpenInMapsButtonProps {
  /** Position à ouvrir. `null`/`undefined`/invalide désactive le bouton. */
  point: MaybeCoordinates | null | undefined;
  /** Nom du SmartTag, affiché comme marqueur à la destination. */
  label: string;
  className?: string;
  size?: 'sm' | 'md';
}

/**
 * Ouvre la position affichée dans l'application cartographique native du
 * téléphone (ou Google Maps dans un nouvel onglet sur desktop). N'affiche
 * qu'un marqueur : ne lance jamais de navigation et ne lit jamais la
 * position du téléphone. Réutilise exclusivement des coordonnées déjà
 * reçues par l'app — aucun appel réseau déclenché par ce composant.
 */
export function OpenInMapsButton({ point, label, className, size = 'md' }: OpenInMapsButtonProps): JSX.Element {
  const target = toMapTarget(point, label);

  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      icon={<MapIcon className="h-4 w-4" aria-hidden />}
      disabled={!target}
      title={target ? undefined : 'Position indisponible'}
      className={className}
      onClick={target ? () => void openInNativeMaps(target) : undefined}
    >
      {target ? 'Ouvrir dans Maps' : 'Position indisponible'}
    </Button>
  );
}
